import { addDisablePortal } from '@hapana/shared/utils/material-ui.util'

/** @type {MuiComponents['MuiDatePicker']} */
const overwrite = {
  defaultProps: {
    PopperProps: addDisablePortal(),
    DialogProps: addDisablePortal(),
  },
}

export const MuiDatePicker = overwrite
